(function(){
  function initSlider(section) {
    if (section.__insaneInit) return;
    section.__insaneInit = true;

    var track = section.querySelector('.insane-slider__track');
    var slides = Array.prototype.slice.call(section.querySelectorAll('.insane-slider__slide'));
    if (!track || slides.length === 0) return;

    var prev = section.querySelector('.insane-slider__arrow--prev');
    var next = section.querySelector('.insane-slider__arrow--next');
    var dotsWrap = section.querySelector('.insane-slider__dots');
    var autoplay = parseInt(section.getAttribute('data-autoplay'), 10) || 0;
    var transition = parseFloat(section.getAttribute('data-transition')) || 0.6;
    var isFade = section.classList.contains('insane-slider--fade');

    // apply overlay color & opacity from settings if present
    var overlayColor = getComputedStyle(section).getPropertyValue('--insane-overlay-color') || '#000';
    var overlayOpacity = getComputedStyle(section).getPropertyValue('--insane-overlay-opacity') || '0.35';
    var overlayEl = section.querySelector('.insane-slider__overlay');
    if (overlayEl) {
      overlayEl.style.background = overlayColor.trim();
      overlayEl.style.opacity = overlayOpacity;
      overlayEl.style.mixBlendMode = 'normal';
      overlayEl.style.pointerEvents = 'none';
      overlayEl.style.background = 'linear-gradient(rgba(0,0,0,0.0), rgba(0,0,0,0.0))';
      // we will not override image but set CSS variable on section instead (CSS used var)
    }

    // set transition duration from data attribute
    section.style.setProperty('--insane-transition-duration', transition + 's');

    var current = 0;
    var timer = null;
    var count = slides.length;

    function update() {
      if (isFade) {
        slides.forEach(function(s, i){
          s.classList.toggle('is-active', i === current);
        });
      } else {
        track.style.transform = 'translateX(' + (-current * 100) + '%)';
      }
      // dots
      if (dotsWrap) {
        var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('button'));
        dots.forEach(function(d){ d.classList.remove('is-active'); });
        if (dots[current]) dots[current].classList.add('is-active');
      }
    }

    function go(i) {
      current = (i + count) % count;
      update();
    }
    function nextSlide(){ go(current + 1); }
    function prevSlide(){ go(current - 1); }

    // create dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i=0;i<count;i++){
        (function(idx){
          var btn = document.createElement('button');
          btn.className = 'insane-slider__dot' + (idx===0 ? ' is-active' : '');
          btn.setAttribute('aria-label','Go to slide ' + (idx+1));
          btn.addEventListener('click', function(){ go(idx); restart(); });
          dotsWrap.appendChild(btn);
        })(i);
      }
    }

    if (next) next.addEventListener('click', function(){ nextSlide(); restart(); });
    if (prev) prev.addEventListener('click', function(){ prevSlide(); restart(); });

    function start(){
      stop();
      if (autoplay && autoplay > 0) timer = setInterval(nextSlide, autoplay * 1000);
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function restart(){ stop(); start(); }

    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', start);
    window.addEventListener('resize', function(){ update(); });

    // initial setup for fade: make first active
    if (isFade) {
      slides.forEach(function(s){ s.classList.remove('is-active'); });
      slides[0] && slides[0].classList.add('is-active');
    }
    update();
    start();
  }

  function initAll(){
    var sections = document.querySelectorAll('.insane-slider');
    sections.forEach(function(s){ try{ initSlider(s);}catch(e){console.error('insane-slider error', e);} });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();